export class LogEntry {
    public error: Error;
}
